import { createFileRoute, redirect } from "@tanstack/react-router";
import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";

export const getCoachOfferRedirect = createServerFn({ method: "GET" })
  .validator(z.object({ username: z.string() }))
  .handler(async ({ data }): Promise<{ offerId: string | null }> => {
    const { getPublicDefaultOfferId } =
      await import("~/lib/server/coach-visibility");
    return { offerId: await getPublicDefaultOfferId(data.username) };
  });

export const Route = createFileRoute("/$username/offer/")({
  beforeLoad: async ({ params }) => {
    const { username } = params;
    const { offerId } = await getCoachOfferRedirect({ data: { username } });

    // A missing, hidden, or offer-less coach lands on the profile, which
    // handles each of those cases itself.
    if (!offerId) {
      throw redirect({ to: "/$username", params: { username } });
    }

    throw redirect({
      to: "/$username/offer/$offerId",
      params: { username, offerId },
    });
  },
});
